import { combineReducers } from 'redux';
// import * as initialState from '../services/session/reducer';
import session from '../services/user/reducer';
import SessionStoreState from '../services/session/types';

import { CourseStoreStateType } from '../services/course/state';
// import { InstructorStoreStateType } from '../services/instructor/state';
import { CourseProgressTrackerState } from '../services/courseProgressTrack/state';
import { GlobalProgressState } from '../services/global/state';
import { NotificationStoreStateType } from '../services/notifications/state';
import { AnalyticsStoreStateType } from '../services/analytics/state';
import { StudentStoreStateType } from '../services/student/state';
import { CourseAnalyticsStateType } from '../services/courseanalytics/state';
import { ApplicationStoreStateType } from '../services/studentActions/applicationForm/state';
import { ProfileStateType } from '../services/studentActions/profile/state';

import course from '../services/course/reducer';
// import instructor from '../services/instructor/reducers';
import progress from '../services/courseProgressTrack/reducer';
import globalProgress from '../services/global/reducers';
import notification from '../services/notifications/reducer';
import courseanalytics from '../services/courseanalytics/reducer';
import student from '../services/student/reducer';
import application from '../services/studentActions/applicationForm/reducers';
import { routerReducer } from 'react-router-redux';
import analytics from '../services/analytics/reducer';
import profile from '../services/studentActions/profile/reducers';
import quiz from '../services/quiz/reducers';
import { EntranceExamStateType } from '../scenes/Students/HOC/withEntranceExam/types';
import entranceExam from '../services/entranceExam/reducers';
import { SyllabusStateType } from '../services/syllabus/types';
import syllabus from '../services/syllabus/reducers';
import sideBar, { SideBarType } from '../services/sidebar/reducer';

export interface RootState {
  session: SessionStoreState;
  course: CourseStoreStateType;
  /* instructor: InstructorStoreStateType; */
  globalProgress: GlobalProgressState;
  progress: CourseProgressTrackerState;
  notification: NotificationStoreStateType;
  analytics: AnalyticsStoreStateType;
  student: StudentStoreStateType;
  courseanalytics: CourseAnalyticsStateType;
  application: ApplicationStoreStateType;
  profile: ProfileStateType;
  entranceExam: EntranceExamStateType;
  syllabus: SyllabusStateType;
  sideBar: SideBarType;
}

export default combineReducers({
  session,
  course,
  /* instructor, */
  notification,
  progress,
  globalProgress,
  analytics,
  student,
  courseanalytics,
  application,
  quiz,
  profile,
  entranceExam,
  syllabus,
  router: routerReducer,
  sideBar,
});
